import * as universal from '../entries/pages/(internal)/_page.ts.js';

export const index = 8;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(internal)/_page.svelte.js')).default;
export { universal };
export const universal_id = "src/routes/(internal)/+page.ts";
export const imports = ["_app/immutable/nodes/8.BZI3l7gR.js","_app/immutable/chunks/scheduler.DHUbek42.js","_app/immutable/chunks/index.ClBRh6_e.js","_app/immutable/chunks/auth.7kXZJxvD.js","_app/immutable/chunks/index.gpef7426.js","_app/immutable/chunks/entry.BL98ULSC.js"];
export const stylesheets = [];
export const fonts = [];
